"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FedopsLoggerDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.FedopsLoggerDefinition = (0, static_service_1.defineStaticService)('viewer-core/fedops-logger');
//# sourceMappingURL=index.js.map